import React from "react";
import { Box, Chip, Stack, styled, Typography } from 'convertupleads-theme';
import { useNavigate } from "react-router-dom";

const HeaderWrapper = styled(Stack)(({ theme }) => ({
  flexDirection:'row',
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.other.outlinedBorder}`,
}));

const Header = () => {
  const navigate = useNavigate();

  return (
    <HeaderWrapper
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Box>
        <Typography
          variant={"h5"}
          color={"text.primary"}
          onClick={() => navigate("/dashboard")}
          sx={{ cursor: "pointer" }}
        >
          Style Guide Doc
        </Typography>
      </Box>
      <Chip label="Version 0.1.8" />
    </HeaderWrapper>
  );
};

export default Header;
